module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "schedulerEl",
    staticClass: "scheduler shrinker"
  }, [_c('div', {
    staticClass: "scheduler__box"
  }, [_c('div', {
    staticClass: "scheduler__inner"
  }, [(_vm.view == 'track') ? _c('div', {
    staticClass: "breakout-track"
  }, [_c('div', {
    staticClass: "align--center"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                        Track — "), _c('span', {
    staticClass: "accent--orange"
  }, [_vm._v(_vm._s(_vm.track.category))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.trackSessions), function(session, index) {
    return _c('div', {
      staticClass: "col-medium-1-2 event-card__container"
    }, [_c('SessionCard', {
      class: {
        'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3
      },
      attrs: {
        "session": session
      },
      on: {
        "clickTimeslot": _vm.showTimeslotBySession,
        "clickSession": _vm.showSession
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.view == 'timeslot') ? _c('div', {
    staticClass: "timeslot"
  }, [_c('div', {
    staticClass: "align--center"
  }, [_c('h2', {
    staticClass: "h1 m-b-0"
  }, [_vm._v("\n                        Timeslot — "), _c('span', {
    staticClass: "accent--orange"
  }, [_vm._v(_vm._s(_vm.timeslot.name))])]), _vm._v(" "), _c('div', {
    staticClass: "timeslot__time",
    domProps: {
      "innerHTML": _vm._s(_vm.getTimeslotTime())
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.timeslotSessions), function(session, index) {
    return _c('div', {
      staticClass: "col-medium-1-2 event-card__container"
    }, [_c('SessionCard', {
      class: {
        'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3
      },
      attrs: {
        "date-link": false,
        "session": session
      },
      on: {
        "clickTimeslot": _vm.showTimeslotBySession,
        "clickSession": _vm.showSession
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.view == 'session') ? _c('div', {
    staticClass: "session"
  }, [_c('div', {
    staticClass: "align--center"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("\n                        Breakout Description\n                    ")]), _vm._v(" "), _c('h2', {
    staticClass: "session__title"
  }, [_vm._v("\n                        " + _vm._s(_vm.session.eventSessionTitle) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "session__details"
  }, [_c('div', {
    staticClass: "session__detail"
  }, [_c('span', {
    staticClass: "session__detail-label"
  }, [_vm._v("\n                        Timeslot\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "session__detail-value"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.session.eventSessionTimeSlot + ' - ' + _vm.showTime(_vm.session.eventSessionStartDT, _vm.session.eventSessionEndDT))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTimeslot(_vm.session.eventSessionTimeSlot)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "session__detail"
  }, [_c('span', {
    staticClass: "session__detail-label"
  }, [_vm._v("\n                        Room\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "session__detail-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.session.eventSessionLocation) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "session__detail"
  }, [_c('span', {
    staticClass: "session__detail-label"
  }, [_vm._v("\n                        Speakers\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "session__detail-value"
  }, _vm._l((_vm.sessionSpeakers), function(speaker) {
    return _c('span', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showSpeaker(speaker)
        }
      }
    }, [_vm._v(_vm._s(speaker.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "session__detail"
  }, [_c('span', {
    staticClass: "session__detail-label"
  }, [_vm._v("\n                        Tracks\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "session__detail-value"
  }, _vm._l((_vm.sessionTracks), function(track) {
    return _c('span', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showTrack(track)
        }
      }
    }, [_vm._v(_vm._s(track.category))])])
  }))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "session__description"
  }, [_vm._v("\n                    " + _vm._s(_vm.session.eventSessionDescription) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.view == 'speaker') ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker__bio-name"
  }, [_vm._v("\n                    " + _vm._s(_vm.speaker.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "speaker__photo",
    style: ({
      backgroundImage: 'url(' + _vm.speaker.webPhoto + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "speaker__about-header"
  }, [_vm._v("\n                    Speaker Bio\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "speaker__bio"
  }, [_vm._v("\n                    " + _vm._s(_vm.speaker.bio) + "\n                ")]), _vm._v(" "), (_vm.speakerSessions) ? _c('div', [_c('div', {
    staticClass: "row row--center"
  }, _vm._l((_vm.speakerTimeslotTypes), function(timeslot) {
    return _c('div', {
      staticClass: "col-medium-1-2"
    }, [(timeslot == 'Breakout') ? _c('div', [_vm._m(1, true), _vm._v(" "), _vm._l((_vm.speakerSessions), function(session, index) {
      return _c('div', {
        staticClass: "event-card__container"
      }, [(session.eventSessionTimeSlot.indexOf(timeslot) != -1) ? _c('SessionCard', {
        class: {
          'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3
        },
        attrs: {
          "session": session
        },
        on: {
          "clickTimeslot": _vm.showTimeslotBySession,
          "clickSession": _vm.showSession
        }
      }) : _vm._e()], 1)
    })], 2) : _vm._e(), _vm._v(" "), (timeslot == 'Workshop') ? _c('div', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.speakerSessions), function(session, index) {
      return _c('div', {
        staticClass: "event-card__container"
      }, [(session.eventSessionTimeSlot.indexOf(timeslot) != -1) ? _c('SessionCard', {
        class: {
          'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3
        },
        attrs: {
          "session": session
        },
        on: {
          "clickTimeslot": _vm.showTimeslotBySession,
          "clickSession": _vm.showSession
        }
      }) : _vm._e()], 1)
    })], 2) : _vm._e()])
  }))]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align--center"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("\n                        About\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speaker__timeslot-header speaker__timeslot-header--breakout"
  }, [_c('div', {
    staticClass: "speaker__timeslot-header-top"
  }, [_vm._v("Conference")]), _vm._v(" "), _c('div', {
    staticClass: "speaker__timeslot-header-big"
  }, [_vm._v("Breakout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speaker__timeslot-header speaker__timeslot-header--workshop"
  }, [_c('div', {
    staticClass: "speaker__timeslot-header-top"
  }, [_vm._v("Youlead")]), _vm._v(" "), _c('div', {
    staticClass: "speaker__timeslot-header-big"
  }, [_vm._v("Workshop")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eff7dad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/ScheduleSwitcher.vue
// module id = 71
// module chunks = 1